// slices/searchSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialStringValue = ''; // Set your initial string value here

const initialState = typeof initialStringValue === 'string' ? initialStringValue : {};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateField: (state, action) => {
      const { field, value } = action.payload;
      return { ...state, [field]: value };
    },
    resetFields: () => initialState,
    setText:(state, action) => {
      return action.payload
    }
  },
});

export const { updateField, resetFields, setText } = searchSlice.actions;
export default searchSlice.reducer;
